import request, {requestJson} from '../main';
const service = ""
class StandardPublicApi {
    private url: string = service + "/measuring-standard-public";

    public pageV2(args: any){
        return request({
            url: this.url + '/page-v2',
            method: 'get',
            params: args
        })
    }

    public page(args: any){
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }
    public mapPage(args: any){
        return request({
            url: this.url + '/mapPage',
            method: 'get',
            params: args
        })
    }
    //新增或者编辑
    public update(params: any){
        return requestJson({
            url: this.url + '/update',
            method: 'post',
            data: params
        })
    }

    public getStandard(args: any){
        return request({
            url: this.url + '/get-by-id',
            method: 'get',
            params: args
        })
    }

    public delete(args: any){
        return request({
            url: this.url + '/delete-by-id',
            method: 'post',
            data: args
        })
    }

    checkEdit(id: number) {
        return request({
            url: this.url + '/check-edit',
            method: 'get',
            params: {
                id: id
            }
        })
    }

    public regionToStandardPublic(args: any){
        return request({
            url: this.url + '/region-to-standard-public',
            method: 'post',
            data: args
        })
    }


    public listUnReplacePublicStandard(args: any){
        return request({
            url: this.url + '/list-un-replace-public-standard',
            method: 'get',
            params: args
        })
    }


    public updateShare(ids: string, shareStatus: number){
        return request({
            url: this.url + '/update-share',
            method: 'post',
            data: {
                ids: ids,
                shareStatus: shareStatus
            }
        })
    }

}
class StandardApi {
    private url: string = service + "/measuring-standard";

    public page(args: any){
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }



    public mapPage(args: any){
        return request({
            url: this.url + '/mapPage',
            method: 'get',
            params: args
        })
    }

    public listUnBindStandard(args: any){
        return request({
            url: this.url + '/list-un-bind-measuring-standard',
            method: 'get',
            params: args
        })
    }


    public getMeasuringStandard(args: any){
        return request({
            url: this.url + '/get-measuring-standard',
            method: 'get',
            params: args
        })
    }
    public pageMeasuringDevices(args: any){
        return request({
            url: this.url + '/page-measuring-devices',
            method: 'post',
            data: args
        })
    }

    public updateShare(ids: string, shareStatus: number){
        return request({
            url: this.url + '/update-share',
            method: 'post',
            data: {
                ids: ids,
                shareStatus: shareStatus
            }
        })
    }

}
const standardPublicApi = new StandardPublicApi();
const standardApi = new StandardApi();
export {standardPublicApi,standardApi}
